import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.103 13.599c-.336-1.706-1.026-3.172-2.042-4.351l1.447-1.255c1.237 1.437 2.07 3.19 2.473 5.232zm.028 2.386 1.821.604c-1.303 3.91-4.13 4.485-5.702 4.485-1.351 0-2.53-.594-3.508-1.486-1.13.892-2.52 1.486-4.159 1.486s-3.133-.94-4.494-2.358C3.575 20.144 1.84 21.074 0 21.074v-1.917c1.351 0 2.674-.757 3.862-1.916C1.552 14.126 0 9.804 0 7.188 0 4.38 2.434 1.917 5.204 1.917s5.338 2.51 5.338 5.27-1.64 7.044-4.15 10.13c1.045 1.121 2.147 1.85 3.191 1.85 1.122 0 2.1-.403 2.894-1.016-1.255-1.783-1.935-3.948-1.935-5.252 0-1.763 1.571-3.306 3.363-3.306s3.345 1.543 3.345 3.306c0 1.447-.738 3.613-2.137 5.348.642.565 1.36.93 2.137.93 1.869 0 3.182-1.074 3.881-3.182zm-15.966-.22c2.051-2.712 3.46-6.402 3.46-8.577 0-1.725-1.668-3.355-3.421-3.355-1.754 0-3.287 1.6-3.287 3.355 0 2.28 1.399 5.913 3.248 8.577m8.683.968c.977-1.342 1.485-2.923 1.485-3.834 0-.7-.709-1.39-1.428-1.39-.718 0-1.447.7-1.447 1.39 0 .91.527 2.492 1.39 3.834"
    }, null, -1)
  ]))]))
}
export default { render: render }